import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Box, Grid } from '@mui/material';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby-theme-material-ui';
import styles from './styles';

function LogosListGatsby({ list, logosData = [], path, aiSection }) {
  const isWidthBelowXl = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const [currentList, setCurrentList] = useState(list);

  useEffect(() => {
    if (isWidthBelowXl) {
      setCurrentList((prev) => prev.filter((item) => !item.isMobileHidden));
    } else {
      setCurrentList(list);
    }
  }, [isWidthBelowXl]);

  return (
    <Box sx={styles.wrapper}>
      <Grid container rowGap={{ xs: '24px', xl: '48px' }}>
        {currentList.map((logo) => (
          <Grid
            item
            sx={styles.item}
            key={logo.image}
            xs={4}
            xl={aiSection ? 4 : 2.25}
          >
            <Box
              sx={styles.imageWrapper}
              component={logo.url ? Link : 'div'}
              to={logo.url}
              target={logo.url && '_blank'}
            >
              <GatsbyImage
                style={styles.imageBlock}
                imgStyle={styles.image}
                image={getImage(logosData[`${path}/${logo.image}`])}
                alt=""
                loading="lazy"
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default LogosListGatsby;
